import { CopilotNotificationConfiguration, CopilotNotificationFeedback, CopilotScript, SetCopilotNotificationFeedbackOutput } from '@coach-bot/data-access/shared/models';
import { AppSyncService } from '@coach-bot/data-access/shared/services/app-sync.service';
import { getGraphQLApiKey, getGraphQLEndpoint } from '@environment';
import { withRetry } from '@shared/http/utils/with-retry';
import { Observable } from 'rxjs';
import { SET_COPILOT_NOTIFICATION_FEEDBACK_MUTATION } from '../mutations';

export class CopilotScriptsService {
  constructor(private appSyncService: AppSyncService) {}

  async getCopilotScripts(): Promise<CopilotScript[]> {
    try {
      const response = await fetch(getGraphQLEndpoint(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': getGraphQLApiKey(),
        },
        body: JSON.stringify({
          query: `{
            getCopilotScripts {
              app
              name
              status
              urlPatterns
              code
            }
          }`,
        }),
      });
      if (response.status === 200) {
        return (await response.json()).data.getCopilotScripts as CopilotScript[];
      } else {
        console.error('Error in API response: ', response);
        throw new Error(`API response is not correct. Status: ${response.status}`);
      }
    } catch (error) {
      throw new Error(`getCopilotScripts failed: ${error}`);
    }
  }

  async getCopilotScriptsWithRetry(): Promise<CopilotScript[]> {
    return withRetry(this.getCopilotScripts.bind(this));
  }

  async getCopilotNotificationConfiguratios(): Promise<CopilotNotificationConfiguration[]> {
    try {
      const response = await fetch(getGraphQLEndpoint(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': getGraphQLApiKey(),
        },
        body: JSON.stringify({
          query: `{
            getCopilotNotificationConfigurations {
              configuration
              name
              status
            }
          }`,
        }),
      });
  
      const jsonResponse = await response.json();
  
      if (response.status === 200) {
        return jsonResponse.data
          ? jsonResponse.data.getCopilotNotificationConfigurations
          : ([] as CopilotNotificationConfiguration[]);
      } else {
        console.error('Error in API response: ', response);
        throw new Error(`API response is not correct. Status: ${response.status}`);
      }
    } catch (error) {
      throw new Error(`getCopilotNotificationConfiguration failed: ${error}`);
    }
  }

  async getCopilotNotificationConfiguratiosWithRetry(): Promise<CopilotNotificationConfiguration[]> {
    return withRetry(this.getCopilotNotificationConfiguratios.bind(this));
  }

  sendCopilotNotificationFeedback(
    copilotNotificationFeedback: CopilotNotificationFeedback,
  ): Observable<SetCopilotNotificationFeedbackOutput> {
    return this.appSyncService
      .mutateViaApiKeyAuth<
        SetCopilotNotificationFeedbackOutput,
        CopilotNotificationFeedback
      >(SET_COPILOT_NOTIFICATION_FEEDBACK_MUTATION, copilotNotificationFeedback);
  }
}
